import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'src/components/ui/dialog';
import {
  type UploadProgress,
  useUploadWidget
} from 'src/context/UploadWidgetContext';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

import DataLibraryUploadDropzone from '../Components/UploadDropzone';
import DataLibraryWebLink from '../Components/WebLink';

enum UploadModalTabs {
  Upload = 'upload',
  WebLink = 'webLink'
}

interface DataLibraryUploadDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const DataLibraryUploadDialog: React.FC<DataLibraryUploadDialogProps> = ({
  open,
  onOpenChange
}) => {
  const { t } = useTranslation();
  const { isResumeUpload } = useUploadWidget();
  const [activeTab, setActiveTab] = useState<UploadModalTabs>(
    UploadModalTabs.Upload
  );
  const toggleUploadModal = () => {
    onOpenChange(false);
  };
  const tabs = [
    {
      text: t(T.upload),
      selected: activeTab === UploadModalTabs.Upload,
      onClick: () => setActiveTab(UploadModalTabs.Upload)
    },
    {
      text: t(T.webLink),
      selected: activeTab === UploadModalTabs.WebLink,
      // Resuming a paused session only resends its own files - switching to
      // WebLink here would abandon that in-progress resume.
      disabled: isResumeUpload,
      onClick: () => setActiveTab(UploadModalTabs.WebLink)
    }
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {activeTab === UploadModalTabs.Upload ? (
        <DataLibraryUploadDropzone
          tabs={tabs}
          toggleUploadModal={toggleUploadModal}
        />
      ) : (
        <DataLibraryWebLink tabs={tabs} toggleUploadModal={toggleUploadModal} />
      )}
    </Dialog>
  );
};

export default DataLibraryUploadDialog;
